/**
 * Cleo ERP SaaS — Page de connexion
 * POST /api/auth/login/ → redirect dashboard (client) ou admin (admin)
 */
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Input, Button, Typography, Alert } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';

const { Title, Text, Paragraph } = Typography;

function LoginPage() {
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const { login, loading } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    setError(null);
    try {
      const user = await login(values.email, values.password);

      if (user.user_type === 'ADMIN') {
        navigate('/admin/tenants');
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      setError(
        err.response?.data?.detail || 'Email ou mot de passe incorrect.'
      );
    }
  };

  return (
    <div>
      <Title level={3} style={{ color: '#0F172A', marginBottom: 4, textAlign: 'center' }}>
        Connexion
      </Title>
      <Paragraph style={{ color: '#64748B', textAlign: 'center', marginBottom: 24 }}>
        Accédez à votre espace Cleo ERP
      </Paragraph>

      {error && (
        <Alert
          message={error}
          type="error"
          showIcon
          closable
          style={{ marginBottom: 16 }}
          onClose={() => setError(null)}
        />
      )}

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        requiredMark={false}
        size="large"
      >
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'L\'email est requis' },
            { type: 'email', message: 'Format email invalide' },
          ]}
        >
          <Input
            prefix={<MailOutlined style={{ color: '#94A3B8' }} />}
            placeholder="votre@email.com"
          />
        </Form.Item>

        <Form.Item
          name="password"
          label="Mot de passe"
          rules={[{ required: true, message: 'Le mot de passe est requis' }]}
        >
          <Input.Password
            prefix={<LockOutlined style={{ color: '#94A3B8' }} />}
            placeholder="Votre mot de passe"
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: 12 }}>
          <Button
            type="primary"
            htmlType="submit"
            block
            loading={loading}
            style={{ height: 44, fontWeight: 600 }}
          >
            Se connecter
          </Button>
        </Form.Item>
      </Form>

      <div style={{ textAlign: 'center' }}>
        <Text style={{ color: '#64748B', fontSize: 13 }}>
          Pas encore inscrit ?{' '}
          <Link to="/register" style={{ fontWeight: 500 }}>Créer une instance</Link>
        </Text>
      </div>
    </div>
  );
}

export default LoginPage;
